import { msg } from "components/schema/msg";
import * as Yup from "yup";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const SettingsSchema = Yup.object().shape({
  sender_email: Yup.string()
    .email(msg("emailFormat"))
    .required(msg("senderEmailRequired")),

  sender_email_password: Yup.string().required(
    msg("senderPasswordRequired")
  ),

  is_all_admin: Yup.boolean(),

  receiver_email: Yup.string().when("is_all_admin", {
    is: false, // Only validate if is_all_admin is false
    then: (schema) =>
      schema
        .required(msg("receiverRequired"))
        .test(
          "has-comma-if-multiple",
          msg("receiverComma"),
          (value) => {
            if (!value) return false;
            const emailCount = value.split(/[ ,;]/).filter(Boolean).length;
            return emailCount <= 1 || value.includes(",");
          }
        )
        .test(
          "valid-email-list",
          msg("receiverInvalid"),
          (value) => {
            if (!value) return false;
            const emails = value
              .replace(/;/g, ",")
              .split(",")
              .map((e) => e.trim())
              .filter(Boolean);
            return emails.every((email) => emailRegex.test(email));
          }
        ),
    otherwise: (schema) => schema.notRequired(), // Skip validation if checkbox is checked
  }),
});
